import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/schedule/eligibility-list')({
  staticData: { team: 'schedule' },
});
